import { styled } from '@mui/material/styles';

const selectedStyles = ({ theme, selected }) =>
  selected
    ? ` 
     border: 1px solid ${theme.DS_palette.primary.main};
     padding: 4px ${theme.DS_spacing(['xxs'])} 4px ${theme.DS_spacing(['xxsx'])};
     ${theme.breakpoints.up('lg')} {
       padding: 2px ${theme.DS_spacing(['xxs'])} 2px ${theme.DS_spacing(['xxsx'])};
     }
  `
    : ` border: 1px solid ${theme.DS_palette.buttons.stroke};
        padding: 8px ${theme.DS_spacing(['xxsx'])};
         ${theme.breakpoints.up('lg')} { 
         padding: 2px ${theme.DS_spacing(['xxsx'])};
         }
    `;

const transitionalStyles = ({ theme, transitional }) =>
  transitional &&
  ` 
      opacity: 0;
      scale: 0.9;
      border: 1px solid ${theme.DS_palette.primary.main};
      transition: all 400ms ease-in-out; 
  `;

const StyledChip = styled('div')(
  ({ theme, selected, transitional }) => `
   background-color: ${theme.DS_palette.background.light};

   width: fit-content;
   border-radius: ${theme.DS_border.radius.labelsTags};
   color: ${theme.DS_palette.primary.main};
   margin: ${theme.DS_spacing(['xxs'])} 0;
   text-transform: uppercase;
   display: flex;
   justify-content: center;
   align-items: center;
   ${selectedStyles({ theme, selected })};
   ${transitionalStyles({ theme, transitional })};

   &:hover {
    cursor: pointer;
   }

   svg {
     fill: none;
     margin-left: ${theme.DS_spacing(['xxxs'])};
     font-size: 20px !important;
     path {
         stroke: ${theme.DS_palette.primary.main};
     }
     &:hover {
      cursor: pointer;
     }
  
   }
 
    ${theme.breakpoints.up('md')} {

      p {
        font-size: 14px !important;
      }
    }
   
  
  `,
);

export { StyledChip };
